import { isPlatformBrowser } from '@angular/common';
import { createIdbKvStore } from './storage/idb-kv-store.util';

const RECENTLY_VIEWED_KEY = 'cnt-recently-viewed';
const RECENTLY_VIEWED_IDB_KEY = 'listing:recently-viewed';
const MAX_ENTRIES = 12;

const store = createIdbKvStore<number[]>({
  legacyKeys: { [RECENTLY_VIEWED_IDB_KEY]: RECENTLY_VIEWED_KEY },
});
// Kick off hydration as early as possible (module load) rather than
// lazily on first call — this module has no single shared bootstrap hook
// (it's plain functions called from many components, not a DI service).
void store.init();

/** Listing ids the user has visited on the detail page, newest first. */
export function readRecentlyViewed(platformId: object): number[] {
  if (!isPlatformBrowser(platformId)) return [];
  const arr = store.read(RECENTLY_VIEWED_IDB_KEY);
  return Array.isArray(arr) ? arr.filter((n): n is number => typeof n === 'number') : [];
}

/** Push a listing id to the front, de-duping any prior occurrence, capped at 12. */
export function pushRecentlyViewed(platformId: object, id: number): void {
  if (!isPlatformBrowser(platformId)) return;
  const current = readRecentlyViewed(platformId).filter((n) => n !== id);
  current.unshift(id);
  const next = current.slice(0, MAX_ENTRIES);
  void store.write(RECENTLY_VIEWED_IDB_KEY, next);
}
